import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FlexContainer } from 'base-components';
import { APPLE_GREEN, DARK_CHARCOAL, GRANITE_GRAY, GREEN_DARK } from '../../../utils/colors';

const tagTypes = {
    'unpicked': '#a4c735',
    'picked': GREEN_DARK,
    'no-stock': '#db5959',
    'substitute': '#4eaccd',
    'partial-picking': '#D5C638',
    'free-picking': '#B0649D',
    'added': GREEN_DARK,
    'picking-pending': '#64908A',
};

const tagTypeBorderColor = {
    'split-order': APPLE_GREEN,
    'monopicking-order': GRANITE_GRAY,
    'bipicking-order': GREEN_DARK
};

const TagBase = styled.div`
    height: 20px;
    border-radius: 4px;
    color: white;
    padding: 4px 8px;
    display: inline-block;
    background: ${props => tagTypes[props.tagType]};
    border: 1px solid ${({ tagType = DARK_CHARCOAL }) => tagTypeBorderColor[tagType]};
    ${props => props.tagType === 'default' && `
        background: transparent;
        border: 1px solid #1fa02e;
        color: #1fa02e;
    `}
`;

const Tag = ({ children, ...props }) => {
    return (
        <TagBase {...props}>
            <FlexContainer align='center' height='100%'>
                {children}
            </FlexContainer>
        </TagBase>
    );
};

Tag.propTypes = {
    children: PropTypes.any,
    tagType: PropTypes.any,
    color: PropTypes.string
};

export default Tag;
